import { useEffect, useState } from "react";
import axios from "axios";
import AppRoutes from "./routes/Routes.jsx";
import { BrowserRouter as Router } from "react-router-dom";
import { AuthProvider } from "./providers/AuthContext.jsx";
import { ToastContainer } from "react-toastify";
import { GamePlayProvider } from "./providers/GamePlayContext.js";
import { SportsbookProvider } from "./providers/SportsbookContext.js";
import UserMaintenance from "./assets/images/technical-maintenance.jpg";
import "react-toastify/dist/ReactToastify.css";
import "./assets/styles/css/global.css";
import "./assets/styles/css/tailwind.css";
import "./assets/styles/css/range-picker.css";
import "./config/i18n";

function App() {
  // const [allowed, setAllowed] = useState(null);

  // useEffect(() => {
  //   const checkCountry = async () => {
  //     try {
  //       const res = await axios.get("https://ipwho.is/");
  //       const countryCode = res.data.country_code; // e.g., "TN"
  //       const allowedCountries = ["TN"]; // Add more codes as needed

  //       // Only restrict in non-local environments
  //       if (process.env.REACT_APP_ENV !== "local") {
  //         if (allowedCountries.includes(countryCode)) {
  //           setAllowed(true); // allowed country
  //         } else {
  //           setAllowed(false); // not allowed
  //         }
  //       } else {
  //         setAllowed(true); // always allow in local
  //       }
  //     } catch (error) {
  //       console.error("Could not determine country", error);
  //       setAllowed(false); // Block access if IP check fails
  //     }
  //   };

  //   checkCountry();
  // }, []);

  return (
    <>
      {/* {allowed ? ( */}
      <AuthProvider>
        <Router>
          <SportsbookProvider>
            <GamePlayProvider>
              <AppRoutes />
            </GamePlayProvider>
          </SportsbookProvider>
        </Router>

        <ToastContainer
          position="bottom-right"
          autoClose={5000}
          hideProgressBar={false}
          newestOnTop={false}
          closeOnClick
          rtl={false}
          pauseOnFocusLoss
          draggable
          pauseOnHover
          theme="dark"
        />
      </AuthProvider>
      {/* ) : (
        <div className="bg-[#161c2c] text-white h-screen flex w-full justify-center items-center">
          <img src={UserMaintenance} alt="not found" />
        </div>
      )} */}
    </>
  );
}

export default App;
